import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { Grid, TextField, Avatar } from "@mui/material";
import logo_icon from '../../../../assets/images/Logo/Bharat-Darshan-Logo.png';
import * as SancharActions from '../../../../redux/actions/sancharAction';
import { api_urls } from "../../../../utils/api-urls";

const AddLive = ({ mode }) => {
    const navigate = useNavigate();
    const location = useLocation();
    const stateData = location?.state?.stateData;
    console.log(stateData);

    const dispatch = useDispatch();

    const [inputFieldDetail, setInputFieldDetail] = useState({ title: stateData?.Title || '', link: stateData?.Link || '', description: stateData?.Description || '' });
    const [inputFieldError, setInputFieldError] = useState({ title: '', link: '', description: '', image: '' });
    const [image, setImage] = useState({ file: api_urls + stateData?.image || logo_icon, bytes: "" });
    const [trending, setTrending] = useState(stateData?.Trending == 'true' ? true : false || false);

    //* Handle Input Field : Error
    const handleInputFieldError = (input, value) => {
        setInputFieldError((prev) => ({ ...prev, [input]: value }))
    };

    //* Handle Input Field : Data
    const handleInputField = (e) => {
        const { name, value } = e.target;
        setInputFieldDetail({ ...inputFieldDetail, [name]: value });
    };

    //* Handle Image
    const handleImage = (e) => {
        if (e.target.files && e.target.files.length > 0) {
            setImage({
                file: URL.createObjectURL(e.target.files[0]),
                bytes: e.target.files[0],
            });
        }

        handleInputFieldError("image", null)
    };

    //! Handle Validation
    const handleValidation = () => {
        let isValid = true;
        const { title, description, link } = inputFieldDetail;
        const { file } = image;

        if (!title) {
            handleInputFieldError("title", "Please Enter Videoclip Name")
            isValid = false;
        }
        if (!link) {
            handleInputFieldError("link", "Please Enter Link")
            isValid = false;
        }
        if (!description) {
            handleInputFieldError("description", "Please Enter Description")
            isValid = false;
        }
        if (!file) {
            handleInputFieldError("image", "Please Select Image")
            isValid = false;
        }
        return isValid;
    };

    //! Handle Submit - Creating Videoclip
    const handleSubmit = async (e) => {
        e.preventDefault();
        if (handleValidation()) {
            console.log("Live Data :: ", { ...inputFieldDetail, trending, image: image?.bytes })
            const { title, link, description } = inputFieldDetail;

            let formData = new FormData()
            formData.append("Title", title)
            formData.append("Link", link);
            formData.append("Description", description);
            formData.append("Trending", trending);
            formData.append("image", image?.bytes);

            const payload = {
                data: formData,
                id: stateData?._id,
                onComplete: () => navigate("/live")
            }

            if (stateData) {
                //! Dispatching API for Updating Live
                dispatch(SancharActions.updateLive(payload));
            } else {
                //! Dispatching API for Creating Live
                dispatch(SancharActions.createLive(payload));
            }
        }
    };

    return (
        <>
            <div style={{ padding: "20px", backgroundColor: "#fff", marginBottom: "20px", boxShadow: '0px 0px 5px lightgrey', borderRadius: "10px" }}>
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "30px", fontFamily: 'Philosopher', backgroundColor: "#fff" }}>
                    <div style={{ fontSize: "20px", fontWeight: "600", color: "#667284" }}>{mode} Live</div>
                    <div onClick={() => navigate("/live")} style={{ fontWeight: "600", backgroundColor: "#164E62", color: "#fff", padding: "5px 10px", borderRadius: "5px", cursor: "pointer", fontSize: "14px" }}>Display</div>
                </div>

                <Grid container sx={{ alignItems: "center" }} spacing={3}>
                    <Grid item lg={6} md={6} sm={12} xs={12} >
                        <TextField
                            label="Title" variant='outlined' fullWidth
                            name='title'
                            value={inputFieldDetail?.title}
                            onChange={handleInputField}
                            error={inputFieldError.title ? true : false}
                            helperText={inputFieldError.title}
                            onFocus={() => handleInputFieldError("title", null)}
                        />
                    </Grid>

                    <Grid item lg={6} sm={6} md={12} xs={12} >
                        <Grid container sx={{ alignItems: "center", flexWrap: "nowrap" }}>
                            <Grid item xs={2} >
                                <Avatar src={image.file} style={{ width: 40, height: 40 }} />
                            </Grid>
                            <Grid component="label" item xs={10} style={{ backgroundColor: "#E2E8F0", textAlign: "center", color: "#666666", padding: "10px 30px", borderRadius: "20px", cursor: "pointer", fontWeight: "500", fontSize: "14px" }}>
                                Upload Image
                                <input onChange={handleImage} hidden accept="image/*" type="file" />
                            </Grid>
                        </Grid>
                        {inputFieldError?.image && <div style={{ color: "#D32F2F", fontSize: "10px", padding: "10px 0 0 15px" }}>{inputFieldError?.image}</div>}
                    </Grid>

                    <Grid item lg={6} md={6} sm={12} xs={12} >
                        <TextField
                            label="Link" variant='outlined' fullWidth
                            name='link'
                            value={inputFieldDetail?.link}
                            onChange={handleInputField}
                            error={inputFieldError.link ? true : false}
                            helperText={inputFieldError.link}
                            onFocus={() => handleInputFieldError("link", null)}
                        />
                    </Grid>

                    <Grid item lg={6} md={6} xs={12} >
                        <div style={{ display: "flex", gap: "20px", border: "1px solid #C4C4C4", padding: "16px 13.5px", borderRadius: "5px" }}>
                            <label style={{ cursor: "pointer", color: "#666666", fontFamily: "Philosopher", fontSize: "13.5px", color: "#667284" }} htmlFor="layout-template">Trending</label>
                            <input defaultChecked={trending} onClick={(e) => setTrending(e.target.checked)} style={{ cursor: "pointer", marginTop: "0px", padding: "0px" }} id='layout-template' type="checkbox" />
                        </div>
                    </Grid>

                    <Grid item lg={12} md={12} sm={12} xs={12} >
                        <TextField
                            label="Description" variant='outlined' fullWidth
                            name='description'
                            value={inputFieldDetail?.description}
                            onChange={handleInputField}
                            error={inputFieldError.description ? true : false}
                            helperText={inputFieldError.description}
                            onFocus={() => handleInputFieldError("description", null)}
                        />
                    </Grid>

                    <Grid item lg={12} md={12} sm={12} xs={12}>
                        <Grid container sx={{ justifyContent: "space-between" }}>
                            <div onClick={handleSubmit} style={{ fontWeight: "500", backgroundColor: "#164E62", color: "#fff", padding: "10px 20px", borderRadius: "5px", cursor: "pointer", fontSize: "15px" }}>Submit</div>
                        </Grid>
                    </Grid>
                </Grid>
            </div>
        </>
    );
};

export default AddLive;